import {
  ExtendedTabId,
  IExtendedTab,
} from "components/ExtendedTabs/ExtendedTabs.types";
import { ISlide } from "./_components/FullStackNetworkingSoftware/FullStackNetworkingSoftware.types";
import { ModelCompareTab } from "./GettingStartedWithUniFi.types";

import SiteManagerScreenPoster from "./assets/screens/why-unifi-site-manager.jpg";
import SiteManagerScreenVideo from "./assets/screens/why-unifi-site-manager.mp4";
import SiteManagerMobileScreenPoster from "./assets/iphone-screens/site-manager-iphone.mp4";
import SiteManagerMobileScreenVideo from "./assets/iphone-screens/site-manager-iphone.jpg";

import SiteMagicScreenPoster from "./assets/screens/why-unifi-site-magic.jpg";
import SiteMagicScreenVideo from "./assets/screens/why-unifi-site-magic.mp4";
import SiteMagicMobileScreenPoster from "./assets/iphone-screens/site-magic-iphone.mp4";
import SiteMagicMobileScreenVideo from "./assets/iphone-screens/site-magic-iphone.jpg";

import UpdateManagerScreenPoster from "./assets/screens/why-unifi-device-updates.jpg";
import UpdateManagerScreenVideo from "./assets/screens/why-unifi-device-updates.mp4";
import UpdateManagerMobileScreenPoster from "./assets/iphone-screens/update-manager-iphone.mp4";
import UpdateManagerMobileScreenVideo from "./assets/iphone-screens/update-manager-iphone.jpg";

import ManageAdminsScreenPoster from "./assets/screens/why-unifi-manage-admins.jpg";
import ManageAdminsScreenVideo from "./assets/screens/why-unifi-manage-admins.mp4";
import ManageAdminsMobileScreenPoster from "./assets/iphone-screens/admin-iphone.mp4";
import ManageAdminsMobileScreenVideo from "./assets/iphone-screens/admin-iphone.jpg";

import CompareWiFiImage from "./assets/tabs/compare/wifi.png";
import CompareCamerasImage from "./assets/tabs/compare/cameras.png";
import CompareDoorAccessImage from "./assets/tabs/compare/door-access.png";

import PageTabSimple from "./assets/tabs/simple.png";
import PageTabLarge from "./assets/tabs/large.png";
import PageTabMassiveScale from "./assets/tabs/massive-scale.png";
import PageTabMultiSite from "./assets/tabs/multi-site.png";

export const SMALL_DEPLOYMENT_SOFTWARE_SLIDES = [
  {
    id: "site-manager",
    index: 0,
    title: "gettingStartedWithUniFi.explore.siteManager.title",
    label: "gettingStartedWithUniFi.explore.siteManager.label",
    description: "gettingStartedWithUniFi.explore.siteManager.description",
    poster: SiteManagerScreenPoster,
    src: SiteManagerScreenVideo,
    mobileSrc: SiteManagerMobileScreenPoster,
    mobilePoster: SiteManagerMobileScreenVideo,
    playbackTimeInSeconds: 5,
  },
  {
    id: "site-magic",
    index: 1,
    title: "gettingStartedWithUniFi.explore.siteMagic.title",
    label: "gettingStartedWithUniFi.explore.siteMagic.label",
    description: "gettingStartedWithUniFi.explore.siteMagic.description",
    poster: SiteMagicScreenPoster,
    src: SiteMagicScreenVideo,
    mobileSrc: SiteMagicMobileScreenPoster,
    mobilePoster: SiteMagicMobileScreenVideo,
    playbackTimeInSeconds: 10.048,
  },
  {
    id: "device-updates",
    index: 2,
    title: "gettingStartedWithUniFi.explore.updates.title",
    label: "gettingStartedWithUniFi.explore.updates.label",
    description: "gettingStartedWithUniFi.explore.updates.description",
    poster: UpdateManagerScreenPoster,
    src: UpdateManagerScreenVideo,
    mobileSrc: UpdateManagerMobileScreenPoster,
    mobilePoster: UpdateManagerMobileScreenVideo,
    playbackTimeInSeconds: 7.616,
  },
  {
    id: "manage-admins",
    index: 3,
    title: "gettingStartedWithUniFi.explore.adminManagement.title",
    label: "gettingStartedWithUniFi.explore.adminManagement.label",
    description: "gettingStartedWithUniFi.explore.adminManagement.description",
    poster: ManageAdminsScreenPoster,
    src: ManageAdminsScreenVideo,
    mobileSrc: ManageAdminsMobileScreenPoster,
    mobilePoster: ManageAdminsMobileScreenVideo,
    playbackTimeInSeconds: 10.048,
  },
] satisfies Array<ISlide>;

export const MODEL_COMPARE_TABS = [
  {
    id: ModelCompareTab.AccessPoints,
    label: "gettingStartedWithUniFi.compareTabs.accessPoints",
    image: CompareWiFiImage,
  },
  {
    id: ModelCompareTab.Cameras,
    label: "gettingStartedWithUniFi.compareTabs.cameras",
    image: CompareCamerasImage,
  },
  {
    id: ModelCompareTab.DoorAccess,
    label: "gettingStartedWithUniFi.compareTabs.doorAccess",
    image: CompareDoorAccessImage,
  },
] satisfies Array<IExtendedTab>;

export const HOW_IT_WORKS_TABS_CONFIG = [
  {
    id: ExtendedTabId.SmallDeployment,
    label: "gettingStartedWithUniFi.tabs.simpleDeployment",
    href: "/how-it-works",
    image: PageTabSimple,
  },
  {
    id: ExtendedTabId.LargeDeployment,
    label: "gettingStartedWithUniFi.tabs.largeDeployment",
    href: "/how-it-works/large",
    image: PageTabLarge,
  },
  {
    id: ExtendedTabId.MassiveScaleDeployment,
    label: "gettingStartedWithUniFi.tabs.massiveScaleDeployment",
    href: "/how-it-works/massive-scale",
    image: PageTabMassiveScale,
  },
  {
    id: ExtendedTabId.MultiSiteDeployment,
    label: "gettingStartedWithUniFi.tabs.multiSiteDeployment",
    href: "/how-it-works/multi-site",
    image: PageTabMultiSite,
  },
] satisfies Array<IExtendedTab>;
